module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('pull-to-refresh', {
    staticClass: "page",
    on: {
      "on-pullup": _vm.onPullup,
      "on-pulldown": _vm.onPulldown
    }
  }, [_c('ul', {
    on: {
      "click": function($event) {
        _vm.testClick($event)
      }
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      key: index
    }, [_vm._v("\n        # item " + _vm._s(index) + " \n      ")])
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-4c2d8a3a!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 78
// module chunks = 2